module.exports = __webpack_public_path__ + "img/image5.de9fc8c2.png";